<template>
  <!-- 我的互动 -->
  <div class="box">
    <div class="t1">{{ $t('我的互动') }}</div>
    <div class="tabbar df jcsb">
      <span class="s1">{{ $t('评论') }}</span>
      <template>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link cup">
            {{ $t(dropdownLabel) }} <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ type: 1 }">{{ $t('只看给我的评论') }}</el-dropdown-item>
            <el-dropdown-item :command="{ type: 2 }">{{ $t('只看我给他人的评论') }}</el-dropdown-item>
            <el-dropdown-item :command="{ type: 3 }">{{ $t('全部') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>

    <div>
      <div class="interaction-box">
        <template v-if="replyData.length">
          <div class="list" v-for="(item, index) in replyData" :key="index" >
            <div class="mt-20 df jcsb">
              <div class="mr-16">
                <template v-if="item.ans_type == 10">
                  <img v-if="item.reply_type == 1" :src="item.user_avatar_url || defaultAvatar" class="avatar" alt="用户头像">
                </template>
                <template v-else>
                  <img :src="defaultAvatar" class="avatar" alt="用户头像">
                </template>
                <span v-if="item.reply_type == 1" class="name ml-8">
                  <template v-if="item.is_expert == 10">
                    {{ item.user_name }}
                  </template>
                  <template v-else>
                    {{ item.ans_type == 10 ? item.user_nick_name : $t('匿名用户') }}
                  </template>
                </span>
                <span class="d1 ml-8">
                  <template v-if="item.reply_type == 1">
                    <template v-if="item.compose_type === 10">{{ $t('给您的帖子') }}</template>
                    <template v-else-if="item.compose_type === 20">{{ $t('给您的文章') }}</template>
                    <template v-else-if="item.compose_type === 30">{{ $t('在活动') }}</template>
                  </template>
                  <template v-if="item.reply_type == 2">
                    <template v-if="item.compose_type === 10">{{ $t('您给帖子') }}</template>
                    <template v-else-if="item.compose_type === 20">{{ $t('您给文章') }}</template>
                    <template v-else-if="item.compose_type === 30">{{ $t('您在活动') }}</template>
                  </template>
                </span>

                <span class="d2 ml-2 cup" @click="handleLink(item)"> {{ item.title }}</span>
                <span class="d1 ml-2">{{ $t('评论') }}</span>
              </div>




              <div class="data fs-12 fn c-7">
                <el-button @click="showPostModal()" class="btns mr-16"> {{ $t('开贴讨论') }}</el-button>
                {{ item.create_time }}
              </div>
            </div>
            <!--            <div class="fs-12 lh-22 mt-8">-->
            <!--            <span class="c-7">-->
            <!--              {{ $t('基于') }}-->
            <!--              <template v-if="item.compose_type === 10">{{ $t('帖子') }}</template>-->
            <!--              <template v-else-if="item.compose_type === 20">{{ $t('文章') }}</template>-->
            <!--              <template v-else-if="item.compose_type === 30">{{ $t('活动') }}</template>-->
            <!--            </span>-->
            <!--              <span style="color: #0067D1;" class="ml-6 cup" @click="handleLink(item)">{{ item.title }}</span>-->
            <!--            </div>-->
            <div v-html="item.content " class="desc fs-14 c-16 lh-20 mt-14"></div>

            <div class="btns df jcfe">
              <el-button type="text" @click="reply(index)"><span class="iconfont">&#xe60b;</span>{{ $t('回复')
                }}</el-button>
              <el-button type="text" @click="likes(item)">
                <span class="iconfont" :class="{ 'c-them': item.have_like == 10 }">{{ item.have_like == 10 ? '&#xe656;'
      :
      '&#xe61b;' }}</span>{{ $t('点赞') }}
              </el-button>
            </div>
            <!-- 输入框 -->
            <div>
              <div class="ipt-box df aic" v-if="index === replyId">
                <el-input type="textarea" v-model="textareaper" :ref="'textareaRef_' + index"
                  :placeholder="$t('回复 OceanClub用户') + (item.is_expert == 10 ? item.user_name:(item.ans_type == 10 ? item.user_nick_name : $t('匿名用户')))"
                  class="f1">
                </el-input>
                <!-- 添加链接插入按钮 -->
                <el-tooltip :content="$t('插入链接')" placement="top">
                      <el-button type="text" class="ml-20 mr-10 custom-link-btn" @click="openLinkDialog(1,index)">
                      <i class="el-icon-link"></i>
                      </el-button>
                  </el-tooltip>
                <img src="@/assets/images/public_send.png" @click="handelSubPerLink(item)" alt="">
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-data">
            <img src="@/assets/images/empty_data.png" alt="">
            <p>{{ $t('暂无数据') }}</p>
          </div>
        </template>

      </div>


    </div>
    <el-dialog
            :visible.sync="dialogVisibleLink"
        :title="$t('请输入链接地址')"
        @close="handleCloseLink"
        >
        <el-input v-model="linkUrl" :placeholder="$t('请输入链接地址')" />
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleLink = false">{{ $t('取消') }}</el-button>
            <el-button type="primary" @click="insertLink">{{ $t('确认') }}</el-button>
        </span>
    </el-dialog>
    <!-- 发布帖子 -->
    <postModel ref="postDialog" :data="data_list" @post-submitted="handlePostModelSubmitted" />
  </div>
</template>

<script>
import { getMyReplyList, } from "@api/expert";
import { getactQuestionLike, setactQuestionAdd } from "@api/active";
import { likePostAns, replyPostAns } from "@api/post";
import { likeArticleAns, replyArticleAns } from "@api/article";
import postModel from "@comp/postModel.vue";
import { addApipost, getcommonData } from "@api/home";
import { markdownToHtml,isValidUrl } from '@/utils/markdownUtils';

export default {
  components: { postModel },
  data() {
    return {
      id: 0,
      replyData: [],
      replyId: 0,
      data_list: {},
      currentType: 1, // 默认类型
      dropdownLabel: '只看给我的评论', // 默认显示的标签
      defaultAvatar: 'https://www.oceanclub.org/static/protal/images/avatar-default.png',
      textareaper: "",
      previewHtml: '',
      dialogVisibleLink: false,  // 控制 Dialog 显示
      linkUrl: '',           // 存储用户输入的链接
      linkType:1,
      linkToContent:'',
      needRefId:0,
    }
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    async handlePostModelSubmitted(content) {
      let res = await addApipost(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },
    showPostModal() {
      this.getIndexCommonData();
      this.$refs.postDialog.openModal();
    },
    async getIndexCommonData() {
      let res = await getcommonData();
      if (res.status == 200) {
        this.data_list = res.data;

      }
    },
    // 初始化获取数据
    async getData() {
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      const res = await getMyReplyList({ user_id: this.userinfo.user_id, type: this.currentType });
      if (res.status == 200) {
        this.replyData = res.data;
      }
    },
    handleCommand(command) {
      this.currentType = command.type; // 更新当前类型
      this.updateDropdownLabel(); // 更新下拉框显示的标签
      this.getData(); // 调用获取评论的接口
    },
    updateDropdownLabel() {
      switch (this.currentType) {
        case 1:
          this.dropdownLabel = '只看给我的评论';
          break;
        case 2:
          this.dropdownLabel = '只看我给他人的评论';
          break;
        case 3:
          this.dropdownLabel = '全部';
          break;
        default:
          this.dropdownLabel = '只看给我的评论';
      }
    },
    reply(index) {
      this.replyId = index;
    },
    async likes(item) {
      if (item.compose_type == 10) {
        let res = await likePostAns({ tpa_id: item.tpa_id });
        if (res.status == 200) {
          this.$message.success(res.data.msg);
        }
      } else if (item.compose_type == 20) {
        let res = await likeArticleAns({ ttara_id: item.ttara_id });
        if (res.status == 200) {
          this.$message.success(res.data.msg);
        }
      } else if (item.compose_type == 30) {
        let res = await getactQuestionLike({ taqa_id: item.taqa_id });
        if (res.status == 200) {
          this.$message.success(res.data.msg);
        }
      }
      this.getData();
    },
    async sendReply(item) {
      let pid = 0;
      let content = (this.linkToContent.length > 0)?this.linkToContent:this.textareaper;
      if (item.compose_type == 10) {
        pid = item.tpa_id;
        if (item.tpa_pid > 0)pid = item.tpa_pid;
        let obj = { tp_id: item.tp_id, tpa_content: content, to_user_id: item.user_id, tpa_pid: pid,is_expert: 10 };
        let res = await replyPostAns(obj);
        if (res.status == 200) {
          this.$message.success(res.msg);
        }
      } else if (item.compose_type == 20) {
        pid = item.ttara_id;
        if (item.ttara_pid > 0)pid = item.ttara_pid;
        let obj = { ttar_id: item.ttar_id, ttara_content: content, to_user_id: item.user_id, ttara_pid: pid,is_expert: 10 };
        let res = await replyArticleAns(obj);
        if (res.status == 200) {
          this.$message.success(res.msg);
        }
      } else if (item.compose_type == 30) {
        pid = item.taqa_id;
        if (item.taqa_pid > 0)pid = item.taqa_pid;
        let obj = { ta_id: item.ta_id, taqa_content: content, to_user_id: item.user_id, taqa_pid: pid,is_expert: 10 };
        let res = await setactQuestionAdd(obj);
        if (res.status == 200) {
          this.$message.success(res.data.msg);
        }
      }
      setTimeout(() => {
        this.replyId = 0;
        this.textareaper = '';
      }, 200);
    },
    handleLink(item) {
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      let str = "/protal";
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      if (item.compose_type == 10) {
        // const url = str + '/post/info/id/' + item.tp_id; //帖子
        // window.open(url, '_blank');
        this.$navigate('/discuss/info', item.tp_id)
      } else if (item.compose_type == 20) {
        // const url = str + '/topicarticle/info/id/' + item.ttar_id; //文章
        // window.open(url, '_blank');
        this.$navigate('/subject/info', item.ttar_id)
      } else if (item.compose_type == 30) {
        let str = '/cn';
        if (Language && Language != 'zh') {
          str = '/' + Language;
        }
        // this.$router.push(str + '/activity/info/' + item.ta_id); //活动
        
        let target={}
        // 判断是否是精英赛
        if(item.ta_kind==30){
            target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
        }else{
            target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
        }
        window.open(target.href, '_blank');
      }


    },
    openLinkDialog(type,index) {
            this.linkUrl = '';
            this.linkType = type; // 保存类型
            this.$nextTick(() => {
              this.dialogVisibleLink = true; // 打开 Dialog
              this.needRefId = index; 
            });
        },
        insertLink() {
            const url = this.linkUrl;
            if (url == '') {
                this.$message.warning(this.$t('请输入链接地址'));
                return;
            }
            if (url) {
                if (!isValidUrl(url)) {
                    this.$message.warning(this.$t('请输入正确的链接地址'));
                    return;
                }
                // 自动提取域名作为显示文本
                try {
                const urlObj = new URL(url);
                } catch (e) {
                // 不是完整URL则保持原样
                }
                // 插入Markdown格式链接
                const markdownLink = `${url}`;
                this.textareaper = this.insertAtCursor(this.textareaper, markdownLink,this.linkType);
                
            }
        },
        
        // 在光标位置插入文本
        insertAtCursor(text, insertText) {
          let str='textareaRef_'+this.needRefId;
            // 获取正确的输入组件
            const inputComponent = this.$refs[str];
            const refName = `textareaRef_${this.currentItemId}`;
            // 获取原生 textarea 元素
            let textarea = null;
            
            if (inputComponent[0]&& inputComponent[0].$refs && inputComponent[0].$refs.textarea) {
                textarea = inputComponent[0].$refs.textarea;
            }
            console.log(textarea)
            // 如果没有获取到 textarea，直接返回原始文本
            if (!textarea) {
                console.error("无法获取 textarea 元素");
                return text;
            }
            
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const insertTextLink = ` ${insertText} `;
            // 更新文本
            const newText = text.substring(0, start) + insertTextLink + text.substring(end);
            
            // 更新光标位置
            this.$nextTick(() => {
                textarea.selectionStart = start + insertTextLink.length;
                textarea.selectionEnd = start + insertTextLink.length;
                textarea.focus();
            });
            this.linkUrl = '';
            this.dialogVisibleLink = false;
            return newText;
        },
        async handelSubPerLink(item) {
            if (!this.textareaper.trim()) {
                this.$message.warning(this.$t('请输入内容'));
                return;
            }
            this.replyLoading = true;
            try {
                // 生成预览
                this.previewHtml = markdownToHtml(this.textareaper);
                
                // console.log(this.previewHtml)
                // return false;
                this.linkToContent = this.previewHtml
                // this.textareaper = this.previewHtml
                this.sendReply(item)
                this.previewHtml = '';
            } catch (error) {
                console.error('回复失败:', error);
                this.$message.error(error.message || this.$t('操作失败'));
            } finally {
                this.replyLoading = false;
            }
        },
        handleCloseLink(){
            this.dialogVisibleLink = false; // 打开 Dialog 
        },
  }


}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid rgb(243, 243, 243);
  border-radius: 8px;
  /* shadow-l */
  box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
  background: rgb(255, 255, 255);
  padding: 24px 40px;
  margin-top: 16px;
}

.tabbar {
  padding-left: 24px;
  margin-top: 20px;

  .s1 {
    color: rgb(25, 25, 25);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 17px;
    font-weight: 400;
    line-height: 24px;
    border-bottom: 1px solid #D80F05;
  }

  ::v-deep() {
    .el-dropdown {
      color: rgb(25, 25, 25);

      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
  }
}

.interaction-box {

  .ipt-box {
    margin-top: 11px;
    min-height: 88px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    background: rgba(25, 25, 25, 0.02);
    padding: 8px 20px 8px 12px;

    ::v-deep() {
      .el-textarea__inner {
        border: none;
        background-color: transparent;
      }
    }
  }

  .avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
  }

  .list {
    &>.list {
      padding-left: 16px;
    }
  }

  .name {
    color: #191919;
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
  }

  .d1 {
    color: #777777;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
  }

  .d2 {
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color: #0067D1;
  }

  .btns {
    margin-top: 8px;

    button {
      color: rgb(119, 119, 119);
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      padding: 0;
      margin-left: 14px;

      .iconfont {
        margin-right: 4px;
      }
    }
  }
}

.t1 {


  color: rgb(25, 25, 25);
  font-family: "MicrosoftYaHeiSemibold";
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}

.data {
  .btns {
    min-width: 61px;
    height: 22px;
    border: 0.5px solid rgb(183, 37, 30);
    border-radius: 23px;
    color: rgb(183, 37, 30);
    font-size: 11px;
    line-height: 20px;
    font-weight: 400;
    padding: 0 6px;
  }
}
.reply-box {
  margin-top: 20px;
  align-items: flex-start; /* 顶部对齐 */
}

.preview-box {
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.content-link {
  color: #409eff;
  text-decoration: none;
  border-bottom: 1px dashed #409eff;
  margin: 0 2px;
}
.content-link:hover {
  color: #66b1ff;
  border-bottom-style: solid;
}
/* 在组件样式部分添加 */
.custom-link-btn  {
    font-size: 18px !important;
}

/* 或者更精确的选择器 */
.custom-link-btn > i {
    font-size: 18px !important;
}
.desc {
  ::v-deep() {
      a {
          color: #00e;
      }
  }
}
</style>